//libs
import { format } from "date-fns";
//components
import Button from "components/Button";
//hooks
import {
  useQuotationQuestionsAndAnswers,
  useTenderQuestionsAndAnswers,
} from "hooks/api/useQuestionsAndAnswers";

export default function QuestionsAndAnswersTable({
  isTender,
  tenderId,
  setOpen,
}: {
  isTender: boolean;
  tenderId: number;
  setOpen: (open: boolean) => void;
}) {
  const useQuestionsAndAnswers = isTender
    ? useTenderQuestionsAndAnswers
    : useQuotationQuestionsAndAnswers;
  const { data } = useQuestionsAndAnswers(tenderId);

  return (
    <div>
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Questions & Answers
          </h1>
          <p className="text-sm text-gray-500">
            This is the section where you can ask about the Tender / Quotation
            for clarification purpose.
          </p>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <Button variant="outline" type="button" onClick={() => setOpen(true)}>
            Add Question
          </Button>
        </div>
      </div>
      <div className="mt-4 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block w-full max-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-auto shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      ID
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Date
                    </th>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      Questions
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Answers
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {data?.data?.map((question: any) => (
                    <tr key={question.id}>
                      <td className="px-3 py-4 text-sm text-gray-500">
                        {question.id}
                      </td>
                      <td className="px-3 py-4 text-sm text-gray-500">
                        {format(question.asked_on, "dd MMM, yyyy")}
                      </td>
                      <td className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                        {question.question}
                      </td>
                      <td className="px-3 py-4 text-sm text-gray-500">
                        {question.answer || "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
